export const Colors = {
  white: '#fff',
  black: '#000',
  backgroundWhite: '#FEFEFF',
  backgroundDark: '#0d0d0d',
  backgroundGray: '#F8FAFA',
  backgroundDarkGray: '#070505',
  backgroundBlue: '#F9FAFB',
  buttonRed: '#F15253',
  buttonBlue: '#1d64f2',
  darkButtonBlue: '#e29b0d',
  coolGray: '#111827',
  darkCoolGray: '#EEE7D8',
  lightGray: '#E0E0E0',
  darkLightGray: '#1F1F1F',
  deepGray: '#666666',
  darkDeepGray: '#999999',
  gray: '#bdbdbd',
  darkGray: '#9e9e9e',
  maastrichtBlue: '#1F2A37',
  maastrichtDarkBlue: '#E0D5C8',
  deepBlue: '#2F70BD',
  darkBlue: '#1B76D2',
  lightBlue: '#2DA8F5',
  blue: '#1976D2',
  red: '#EF9A9A',
  strongRed: '#F82600',
  purple: '#7986CB',
  pink: '#e20478',
  orangeRed: '#FF4500',
  green: '#30c48c',
  error: '#FF3333',
}
